import Contact from "../Contact";
import HeroSection from "../HeroSection";
import Navigation from "../Navigation";
import Projects from "../Projects";
import AboutMe from "../AboutMe";
import CursorEffect from "../CursorEffect";
import Experience from "../Experience";

export default function Home() {
  return (
    <>
      <CursorEffect />
      <Navigation />
      <HeroSection />
      <AboutMe />
      <Experience />
      <Projects />
      <Contact />
    </>
  );
}
